import type { ReactNode } from 'react';
import type { ExamReportResponse } from '../../../api/types';
import { PanelCard, StatStrip } from '../../../components/ui';

// Six headline numbers in one card (design `.strip`).
export default function ReportHeader({ h }: { h: ExamReportResponse['header'] }) {
  const pct = (v: number | null) => (v == null ? '—' : `${v.toFixed(1)}%`);
  const delta = h.delta_vs_prior_on_same_subject;
  const tinted = (text: string, bad: boolean | null): ReactNode =>
    bad == null ? text : <span className={bad ? 'text-danger-ink' : 'text-success'}>{text}</span>;
  const late = h.late_count ?? 0;
  const tiles: Array<{ label: string; value: ReactNode; help: string }> = [
    { label: 'Took / assigned',
      value: late > 0 ? <>{`${h.took_count}/${h.assigned_count}`}<span className="text-base text-muted">{` (+${late} late)`}</span></> : `${h.took_count}/${h.assigned_count}`,
      help: 'Students who took the exam before answers were released, out of everyone in the cohort it was assigned to. Late submissions (after answers were released) are shown as +late and are not counted in any figure here.' },
    { label: 'Average', value: pct(h.avg_score), help: 'Mean score of the students who took the exam before answers were released; late submissions are not counted.' },
    { label: 'Median', value: pct(h.median_score), help: 'median' },
    { label: `Pass rate ≥${h.pass_score_pct}%`, help: 'pass_rate',
      value: h.pass_rate == null ? '—' : tinted(`${(h.pass_rate * 100).toFixed(1)}%`, h.pass_rate < 0.5) },
    { label: 'Avg time', help: 'avg_time',
      value: h.avg_duration_minutes == null ? '—' : <>{h.avg_duration_minutes.toFixed(1)}<span className="text-base"> min</span></> },
    { label: 'Vs prior exam', help: 'vs_prior',
      value: delta == null ? '—' : tinted(`${delta > 0 ? '+' : ''}${delta.toFixed(1)}`, delta < 0) },
  ];
  return (
    <PanelCard size="filter">
      <StatStrip divided columns={6} items={tiles} />
    </PanelCard>
  );
}
